import script from "./PhysicalExamination.vue?vue&type=script&setup=true&lang=js"
export * from "./PhysicalExamination.vue?vue&type=script&setup=true&lang=js"

import "./PhysicalExamination.vue?vue&type=style&index=0&id=e23b3284&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e23b3284"]])

export default __exports__